import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import { useManyRefs } from '@carnica/utils/hooks';
var allowedKeys = ['ArrowDown', 'ArrowUp', 'Space', 'Enter', 'Escape'];
export var useContextMenuNavigation = function useContextMenuNavigation(props) {
  var items = props.items,
    onEsc = props.onEsc,
    isOpen = props.isOpen,
    anchorRef = props.anchorRef;
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var containerRef = useRef(null);
  var refs = useManyRefs(items.length);
  var onKeyDown = function onKeyDown(e) {
    var code = e.code;
    if (!allowedKeys.includes(code)) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    if (code === 'ArrowUp') {
      setActiveIndex(Math.max(activeIndex - 1, 0));
    }
    if (code === 'ArrowDown') {
      setActiveIndex(Math.min(activeIndex + 1, items.length - 1));
    }
    if ((code === 'Enter' || code === 'Space') && activeIndex >= 0) {
      var _refs$activeIndex$cur;
      (_refs$activeIndex$cur = refs[activeIndex].current) === null || _refs$activeIndex$cur === void 0 || _refs$activeIndex$cur.click();
    }
    if (code === 'Escape') {
      var _anchorRef$current;
      onEsc === null || onEsc === void 0 || onEsc(e);
      anchorRef === null || anchorRef === void 0 || (_anchorRef$current = anchorRef.current) === null || _anchorRef$current === void 0 || _anchorRef$current.focus();
    }
  };
  useEffect(function () {
    setActiveIndex(-1);
    setTimeout(function () {
      var _containerRef$current;
      return (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.focus();
    }, 600);
  }, [isOpen]);
  return {
    refs: refs,
    activeIndex: activeIndex,
    onKeyDown: onKeyDown,
    containerRef: containerRef
  };
};